import { useState, useEffect } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { EmptyState } from "@/components/Primitives";
import { ScrollText, Search } from "lucide-react";

const ACTION_TONE = (a) => {
  if (/purge|delete|deactiv|login_failed/.test(a)) return "bg-[#FE421C]/12 text-[#C42607]";
  if (/create|invite|upload|assign|restore|login_success|share/.test(a)) return "bg-[#9ACC32]/15 text-[#5B880C]";
  return "bg-[#00C9E0]/12 text-[#0094A8]";
};

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs?limit=300").then((r) => setRows(r.data.items)); }, []);
  const filtered = rows.filter((r) => !q || `${r.user_name} ${r.action} ${r.entity_type}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-audit">
      <div className="relative mb-4 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input className="pl-9" placeholder="Search audit events…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" />
      </div>
      {filtered.length === 0 ? (
        <div className="cc-card"><EmptyState icon={ScrollText} title="No audit events" hint="Administrative and security events are recorded here." /></div>
      ) : (
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead><tr className="border-b bg-slate-50/80 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3">When</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Entity</th>
            </tr></thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id} className="border-b border-slate-100" data-testid={`audit-${r.id}`}>
                  <td className="px-4 py-2.5 text-slate-500 tnum whitespace-nowrap">{fmtDateTime(r.timestamp)}</td>
                  <td className="px-4 py-2.5 font-medium text-slate-700">{r.user_name}</td>
                  <td className="px-4 py-2.5"><span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${ACTION_TONE(r.action)}`}>{r.action}</span></td>
                  <td className="px-4 py-2.5 text-slate-500">{r.entity_type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
